import type { StrictPost } from '$lib/types'

export const meta: StrictPost = {
	title: 'Quotes',
	description: 'Quotes about risks from artificial intelligence',
	date: '2024-01-26',
	slug: 'quotes',
	categories: []
}
